import axios from 'axios';
import {getToken, clearAuth} from '@/services/authStorage';
import { withBase } from '@/util/base';

// API-Instanz
const api = axios.create({
    baseURL: process.env.VUE_APP_API_BASE || '/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

function activateMaintenanceMode(payload) {
    const msg = String(payload?.message || 'Die App ist aktuell im Wartungsmodus.');

    try {
        localStorage.setItem('app_maintenance', '1');
        localStorage.setItem('app_maintenance_message', msg);
    } catch (e) {
        /* no-op */
    }

    // Nicht in Endlosschleife navigieren
    try {
        if (window.location.pathname !== withBase('maintenance')) {
            window.location.assign(withBase('maintenance'));
        }
    } catch (e) {
        /* no-op */
    }
}

function makeMaintenanceError(payload) {
    const err = new Error('MAINTENANCE');
    err.code = 'MAINTENANCE';
    err.payload = payload || null;
    return err;
}

// Request-Interceptor - KORRIGIERT
api.interceptors.request.use(
    config => {

        // Token bei jedem Request frisch lesen (nicht auf api.defaults verlassen)
        const token = getToken();

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // ✅ Finaler Header-Check

        return config;
    },
    error => {
        console.error('❌ Request interceptor error:', error);
        return Promise.reject(error);
    }
);

// Response-Interceptor - erweitert
api.interceptors.response.use(
    response => {
        const data = response?.data;

        // Wartungsmodus als "normale" 200-Response erkennen
        if (data && typeof data === 'object' && data.code === 'MAINTENANCE') {
            activateMaintenanceMode(data);
            return Promise.reject(makeMaintenanceError(data));
        }

        return response;
    },
    async error => {
        console.error('🚨 API Response Error:', error.response?.status, error.message);

        // Backward-Compatibility: falls irgendwo noch 503 kommt
        const data = error?.response?.data;
        if (data && typeof data === 'object' && data.code === 'MAINTENANCE') {
            activateMaintenanceMode(data);
            return Promise.reject(makeMaintenanceError(data));
        }

        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            if (originalRequest.url.includes('/login')) {
                return Promise.reject(error);
            }

            console.warn('⚠️ 401 on protected route - clearing auth and redirecting');
            // Nur Auth-Daten entfernen; Wartungsmodus-Flags u. ä. bleiben erhalten
            clearAuth();
            window.location.assign(withBase('login'));
            return Promise.reject(error);
        }

        return Promise.reject(error);
    }
);

export default api;